import React from 'react';
import PropTypes from 'prop-types';
import getNavLink from './nav-links';

const NavbarDropdownListItem = ({
  label,
  link,
  badge,
  openNewTab
}) => (
  <a
    tabIndex="0"
    className="dropdown-item"
    href={link || getNavLink(label) || ''}
    target={openNewTab ? '_blank' : '_self'}
  >
    {label}
    {badge && <span className="badge badge-default" style={{ marginLeft: '5px' }}>{badge.toUpperCase()}</span>}
  </a>
);


NavbarDropdownListItem.defaultProps = {
  link: '',
  badge: undefined,
  openNewTab: false
};

NavbarDropdownListItem.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string,
  badge: PropTypes.string,
  openNewTab: PropTypes.bool
};

export default NavbarDropdownListItem;
